import { type SearchParamsOption } from "ky/distribution/types/options";

import { LocationLevel } from "../../enums/location-level";
import { client } from "../client";

export declare interface SearchLocationsInput {
	level: LocationLevel;
	take: number;
	query?: string;
	parentId?: string;
	allowedDistricts?: readonly string[];
}

export declare interface SearchLocationItem {
	id: string;
	name: string;
	code: string;
	alternativeCode: string | null;
	districtName: string | null;
}

export async function searchLocations(input: SearchLocationsInput): Promise<readonly SearchLocationItem[]> {
	const params: SearchParamsOption = [["level", input.level]];

	if (input.take !== undefined) {
		params.push(["take", input.take.toString(10)]);
	}

	if (input.query !== undefined) {
		params.push(["query", input.query]);
	}

	if (input.parentId !== undefined) {
		params.push(["parentId", input.parentId]);
	}

	if (input.allowedDistricts !== undefined) {
		for (const district of input.allowedDistricts) {
			params.push(["allowedDistricts", district]);
		}
	}

	return await client
		.get("/_api_v0/location/search/v1", {
			searchParams: params,
		})
		.json();
}
